module.exports = __webpack_public_path__ + "img/about-images-founders-profiles-alexandre.0fc5abfc.webp";